<template>
    <div>
        no-template
    </div>
</template>

<script>
    export default {
        name: "no-template"
    }
</script>

<style scoped>

</style>